import { type LineCustomSvgLayer } from '@nivo/line'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Fragment } from 'react'
import { type LineChartSeries } from './types'

export const LineChartCustomPrediction: LineCustomSvgLayer<LineChartSeries> = ({ series, lineGenerator }) => {
    return series.map((serie) => {
        // We currently only support predictions into the future, and we only support a single prediction point
        const lastPoint = serie.data.at(-1)
        if (!lastPoint?.data.isPrediction) {
            return null
        }

        return (
            <Fragment key={serie.id}>
                <path
                    style={{ strokeDasharray: '4 4', fill: 'none' }}
                    d={lineGenerator(serie.data.slice(-2).map((d) => ({ x: d.position.x, y: d.position.y }))) || undefined}
                    stroke={tokens.ColorGraphNeutralMedium}
                />
                <circle
                    key={`${serie.id}-${lastPoint.data.date}`}
                    r={serie.smallDots ? 1.5 : 3.5}
                    strokeWidth={1}
                    cx={lastPoint.position.x}
                    cy={lastPoint.position.y}
                    stroke={tokens.ColorGraphNeutralMedium}
                    fill={tokens.ColorGraphNeutralMedium}
                />
                <text
                    x={lastPoint.position.x}
                    y={lastPoint.position.y - 10}
                    fill={tokens.ColorTextDefault}
                    fontSize={tokens.GraphLabel.fontSize}
                    fontFamily={tokens.GraphLabel.fontFamily}
                    textAnchor="middle"
                >
                    {lastPoint.data.label}
                </text>
            </Fragment>
        )
    })
}
